"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeReturnStatement = void 0;
const react_peg_1 = require("react-peg");
const common_1 = require("../common");
// import { ITypeIfStatement, TypeIfStatement } from "./if-statement";
const expression_1 = require("../expression");
function TypeReturnStatement() {
    const action = ({ arg }) => {
        return {
            kind: "TypeReturnStatement",
            argument: arg
        };
    };
    return (react_peg_1.ReactPeg.createChunk("pattern", { action: action },
        common_1.Text("return"),
        react_peg_1.ReactPeg.createChunk(expression_1.TypeExpression, { label: "arg" })));
}
exports.TypeReturnStatement = TypeReturnStatement;
